/**
 * Shared chart theme — light glassmorphism. Ported from
 * D:\campaigning-system\src\components\charts\chartTheme.ts.
 *
 * Palettes validated with the dataviz skill validator: 2-series time
 * (teal + bronze) passes; the status categorical set has CVD separation and is
 * intentionally muted (anti-rainbow), with legends + direct value labels as the
 * required relief. Color is assigned by role, never cycled — except `palette`
 * below, a muted categorical fallback for arbitrary (non-status) donut slices,
 * kept within the same restrained hue family.
 */
export const chart = {
  teal: '#0A9188',
  tealBright: '#16B8AA',
  tealDeep: '#087F78',
  bronze: '#B0872F', // warm secondary series
  blueTeal: '#3E7C8C', // muted supporting
  grid: 'rgba(70,80,72,0.09)',
  axis: '#7B847F',
  axisLine: 'rgba(70,80,72,0.14)',
  label: '#56615C',
  // Status categorical (Running / Completed / Scheduled / Draft)
  status: {
    Running: '#0FA89B',
    Completed: '#0E7E68',
    Scheduled: '#C6982F',
    Draft: '#949E9A',
  },
  // Muted categorical fallback for arbitrary donut slices (delivery breakdown,
  // corrected-field mix, …). Same restrained family as the rest of the system.
  palette: ['#0A9188', '#B0872F', '#3E7C8C', '#B7AD96', '#12A99B', '#949E9A'],
  // Sequential teal ramp for funnel / magnitude (light -> deep)
  ramp: ['#7FD3C9', '#38BEB0', '#12A99B', '#0A9188', '#087F78'],
};

export const axisTick = { fill: chart.axis, fontSize: 11, fontFamily: 'Hanken Grotesk' };

export const tooltipStyle = {
  contentStyle: {
    background: 'rgba(255,255,255,0.92)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255,255,255,0.8)',
    borderRadius: 12,
    boxShadow: '0 12px 34px rgba(45,55,48,0.14)',
    fontSize: 12,
    fontFamily: 'Hanken Grotesk',
    padding: '8px 12px',
  },
  labelStyle: { color: '#17201D', fontWeight: 700, marginBottom: 2 },
  itemStyle: { color: '#56615C', padding: 0 },
  cursor: { stroke: 'rgba(15,168,155,0.35)', strokeWidth: 1 },
};
